@if (content) {
  <!-- 모든 보고서 카드가 동일한 공통 상태로 자연스럽게 확장되도록 연결 -->
  <div
    class="extendable-card bg-gray-light p-l-20 p-r-15 p-t-30 brd-20"
    [class.extendable-card--expanded]="expanded"
    fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" class="title">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="7px">
        <div class="text-14 f-w-700 m-b-0 p-b-5">{{ content.title }}</div>
        <div fxLayoutAlign="start center" fxLayoutGap="7px">
          @for (badge of content.badges; track badge) {
            <div class="bg-chip-xs bg-gray-da">{{ badge }}</div>
          }
        </div>
      </div>
      @if (content.items.length > 0) {
        <!-- 펼침 버튼의 접근성 상태와 아이콘을 공통 상태에 맞춰 갱신 -->
        <button mat-icon-button (click)="toggle()" [attr.aria-expanded]="expanded" fxFlexAlign="center">
          <mat-icon class="c-black">{{ expanded ? 'arrow_drop_up' : 'arrow_drop_down' }}</mat-icon>
        </button>
      }
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center" class="extendable-card__summary p-b-25">
      <div class="extendable-card__value text-15 f-w-750">{{ content.value }}</div>
      <div class="extendable-card__sub-value text-14 f-w-600">{{ content.subValue }}</div>
    </div>

    <!-- 내용 높이와 투명도를 함께 전환해 열림과 닫힘을 모두 부드럽게 표시 -->
    <div class="extendable-card__details" [@expandCollapse]="expanded ? 'open' : 'closed'">
      <div class="extendable-card__panel shadow-box-none border-none bg-gray-light p-t-10">
        <div class="mat-expansion-panel-body">
          @for (item of content.items; track item) {
            <div fxLayout="row" fxLayoutAlign="space-between start" class="p-b-5">
              <div>{{ item.name }}</div>
              <div class="f-w-600">{{ item.value }}</div>
            </div>
          }

          <div class="p-v-25 f-13 f-w-600">{{ content.explain }}</div>
        </div>
      </div>
    </div>
  </div>
  <ng-content></ng-content>

}
